import React from 'react'

import { ReactComponent as GridIcon } from '../../../assets/grid-icon.svg'
import { ReactComponent as PinIcon } from '../../../assets/pin-icon.svg'

import { MapTogglesContainer, ToggleButton } from './styles'

const MapToggles = ({ showMapView, onShowMapView, onHideMapView }) => (
  <MapTogglesContainer
    className="toggle-group-map"
    size="small"
    variant="outlined"
    aria-label="small outlined button group"
  >
    <ToggleButton
      id="map-view"
      selected={showMapView}
      variant="outlined"
      size="large"
      onClick={onShowMapView}
    >
      <PinIcon fill={showMapView ? 'white' : 'rgba(26,25,25,0.4)'} />
    </ToggleButton>

    <ToggleButton
      id="grid-view"
      selected={!showMapView}
      variant="outlined"
      size="large"
      onClick={onHideMapView}
    >
      <GridIcon fill={showMapView ? 'rgba(26,25,25,0.4)' : 'white'} />
    </ToggleButton>
  </MapTogglesContainer>
)

export { MapToggles }
